import React from "react";

export const ListboxWrapper = ({children}) => (
  <div>
    {children}
  </div>
);
